import { Component,Inject,OnInit,PLATFORM_ID,Renderer2,TemplateRef,ViewChild } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup } from '@angular/forms';
import { FormBuilder,Validators } from '@angular/forms';
import { MainserviceService } from 'src/app/mainservice.service';
import Swal from 'sweetalert2';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoSocialShareService, SeoSocialShareData } from 'ngx-seo';
import { JsonLdService } from 'ngx-seo';
@Component({
  selector: 'app-medeilpos',
  templateUrl: './medeilpos.component.html',
  styleUrls: ['./medeilpos.component.scss'],
  providers:[MainserviceService,DatePipe]
})

export class MedeilposComponent implements OnInit {
  search : String ="";
  enquiryForm:FormGroup;
  totalcountry:any=[];
  captcha:any
  errorcaptcha:any
  ecaptcha:boolean=false;
  dialcode:any;
  showElement: boolean = false;
  showElementsave: boolean = false;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild('inputField') inputField!: any;
  currentTime: Date;
  timeSlots:any=[];
  timezone:any;
  appointment_time:boolean=false;
  selectedTime: string | null = null;
  leads:any;
constructor(private ngxsmartservice:NgxSmartModalService,private fb:FormBuilder,private route: ActivatedRoute,private router:Router, private seoService: SeoSocialShareService,
private jsonLdService: JsonLdService,private mainservice:MainserviceService,private datePipe: DatePipe,private title:Title,private meta:Meta,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: Object){
  if (isPlatformBrowser(this.platformId)) {
    this.setSeoMeta();
    this.setSchema();
    this.setFaqSchemaData();
    this.setWebsiteSchema();
  

    // this.title.setTitle('Pharmacy Management System | Optical Shop | Pet Store & More');

    // // Add meta tags dynamically
    // this.meta.addTag({name: 'description', content: 'Unlock Efficiency with the Best Software with 15 years Experience unrivaled performance and reliability. Get the best pharmacy, optical, veterinary, agrochemical, medical device, beauty & cosmetics software now!' });

    // this.meta.addTag({ name: 'keywords', content: 'Pharmacy application, Pharmacy app, Optical shop software, Pet store POS, Pharmacy POS, Software for pharmacy' });
    // this.route.queryParams.subscribe(params => {
    //   this.queryParams = params;
    // });
    this.timezone=sessionStorage.getItem('timezone');
  this.enquiryForm=this.fb.group({
      leadname: ['',[ Validators.required]],
      organizationname: ['',[Validators.required]],
      leadsourceid: ['',[]],
      leadsource: ['medeil website',[]],
      sourceRef1: ['',[]],
      sourceRef2: ['',[]],
      description: ['',[ Validators.required]],
      primaryphone: ['',[Validators.required]],
      primaryemail: ['',[Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
      address1: ['',[]],
      address2: ['',[]],
      country: [sessionStorage.getItem('country'),[],[]],
      countryname1: ['0',[]],
      state: [sessionStorage.getItem('state'),[]],
      city: [sessionStorage.getItem('city'),[]],
      enteredcaptcha: ['',[]],
      generatedcaptcha: ['',[]],
      phonedialcode:['',[]],
      checkbox:[false,[]],
      appfrmtime:['',[]],
      apptotime:['',[]],
      appointmentdate:['',[]],
    })
  }
}

  selectedclass: number = 1;
 


  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: $localize`:@@SEO.TITLE_POS:Medeil Free Pharmacy Management Software: Streamline Your Operations`,
  //     description: $localize`:@@SEO.DESCRIPTION_POS:Explore Medeil, the comprehensive medical store software designed to enhance efficiency in pharmacies and hospital pharmacies. Discover features like drug information, distributor details, stock management, pharmacy billing, and pharmacist register with schedule reports to optimize your medical shop or chemist store operations.`,
  //     image: 'https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg',
  //     url: 'https://www.medeil.com/en/medeil-pharmacy-software',
  //     keywords: $localize`:@@SEO.KEYWORDS_POS:Pharmacy management system, Free Pharmacy software, Medical store software, Pharmacy Billing software, Medeil software`
  //   };
  
  //   this.seoService.setData(seoData);
  // }

  setSeoMeta() {
    const supportedLanguages = ['en', 'fr', 'es', 'pt'];
    let finalUrl = '';
  
    if (isPlatformBrowser(this.platformId)) {
      const origin = window.location.origin;
      const path = window.location.pathname;
      const parts = path.split('/');
  
      let lang = 'en'; // Default
      if (supportedLanguages.includes(parts[1])) {
        lang = parts[1];
      }
  
      // const fullPath = path.replace(/^\/[a-z]{2}/, '');
      // finalUrl = `${origin}/${lang}${fullPath}`;
      const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

    }
  
    const seoData: SeoSocialShareData = {
      title: $localize`:@@SEO.TITLE_POS:Medeil Free Pharmacy Software – Boost Efficiency`,
      description: $localize`:@@SEO.DESCRIPTION_POS:Streamline pharmacy operations with Medeil. Manage stock, billing, drug info & reports — ideal for pharmacies & medical stores.`,
      image: 'https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg',
      url: 'https://www.medeil.com/en/medeil-pharmacy-software',
      keywords: $localize`:@@SEO.KEYWORDS_POS:Pharmacy management system, Free Pharmacy software, Medical store software, Pharmacy Billing software, Medeil software`
    };

  
    this.title.setTitle(seoData.title);
  
    const metaTags = [
      { name: 'description', content: seoData.description },
      { name: 'keywords', content: seoData.keywords }, 
      { property: 'og:title', content: seoData.title },
      { property: 'og:description', content: seoData.description },
      { property: 'og:url', content: seoData.url },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: seoData.image }
    ];
  
    metaTags.forEach(tag => this.meta.updateTag(tag));
  }
  // setSeoMeta() {
  //   const supportedLanguages = ['en', 'fr', 'es', 'pt'];
  //   let finalUrl = '';
  //   let lang = 'en';
  
  //   if (isPlatformBrowser(this.platformId)) {
  //     const origin = window.location.origin;
  //     const path = window.location.pathname;
  //     const parts = path.split('/');
  
  //     if (supportedLanguages.includes(parts[1])) {
  //       lang = parts[1];
  //     }
  
  //     const fullPath = path.replace(/^\/[a-z]{2}/, '');
  //     finalUrl = `${origin}/${lang}${fullPath}`;
  //   }
  
  //   const seoData: SeoSocialShareData = {
  //         title: $localize`:@@SEO.TITLE_POS:Medeil Free Pharmacy Management Software: Streamline Your Operations`,
  //         description: $localize`:@@SEO.DESCRIPTION_POS:Explore Medeil, the comprehensive medical store software designed to enhance efficiency in pharmacies and hospital pharmacies. Discover features like drug information, distributor details, stock management, pharmacy billing, and pharmacist register with schedule reports to optimize your medical shop or chemist store operations.`,
  //         image: 'https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg',
  //         url: 'https://www.medeil.com/en/medeil-pharmacy-software',
  //         keywords: $localize`:@@SEO.KEYWORDS_POS:Pharmacy management system, Free Pharmacy software, Medical store software, Pharmacy Billing software, Medeil software`
  //       };
  
  //   this.title.setTitle(seoData.title);
  
  //   const metaTags = [
  //     { name: 'description', content: seoData.description },
  //     { name: 'keywords', content: seoData.keywords },
  //     { property: 'og:title', content: seoData.title },
  //     { property: 'og:description', content: seoData.description },
  //     { property: 'og:url', content: seoData.url },
  //     { property: 'og:type', content: 'website' },
  //     { property: 'og:image', content: seoData.image }
  //   ];
  
  //   metaTags.forEach(tag => this.meta.updateTag(tag));
  // }

  // setSeoMeta() {
  // const supportedLanguages = ['en', 'fr', 'es', 'pt'];
  // let finalUrl = '';

  // if (isPlatformBrowser(this.platformId)) {
  //   const origin = window.location.origin;
  //   const path = window.location.pathname;
  //   const parts = path.split('/');

  //   let lang = 'en'; // Default
  //   if (supportedLanguages.includes(parts[1])) {
  //     lang = parts[1];
  //   }

  //   const fullPath = path.replace(/^\/[a-z]{2}/, '');
  //   finalUrl = `${origin}/${lang}${fullPath}`;
  // }

  //   const seoData = {
  //     title: 'Medeil Free Pharmacy Management Software: Streamline Your Operations',
  //     description: 'Explore Medeil, the comprehensive medical store software designed to enhance efficiency in pharmacies and hospital pharmacies. Discover features like drug information, distributor details, stock management, pharmacy billing, and pharmacist register with schedule reports to optimize your medical shop or chemist store operations.',
  //     image: 'https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg',
  //     url: finalUrl,
  //     keywords: 'Pharmacy management system, Free Pharmacy software, Medical store software, Pharmacy Billing software, Medeil software'
  //   };

  //   // this.seoService.setData(seoData);
  //   this.title.setTitle(seoData.title);
  //   const metaTags = [
  //     { name: 'description', content: seoData.description },
  //     { name: 'keywords', content: seoData.keywords }, 
  //     { property: 'og:title', content: seoData.title },
  //     { property: 'og:description', content: seoData.description },
  //     { property: 'og:url', content: seoData.url },
  //     { property: 'og:type', content: 'website' },
  //     { property: 'og:image', content: seoData.image }
  //   ];
  
  //   metaTags.forEach(tag => this.meta.updateTag(tag));
  // }
  // setSeoMeta() {
  //   const supportedLanguages = ['en', 'fr', 'es', 'pt'];
  //   let finalUrl = '';
  
  //   // Define the SEO meta data translations for each language
  //   const seoDataByLang = {
  //     en: {
  //       title: 'Medeil Free Pharmacy Management Software: Streamline Your Operations',
  //       description: 'Explore Medeil, the comprehensive medical store software designed to enhance efficiency in pharmacies and hospital pharmacies. Discover features like drug information, distributor details, stock management, pharmacy billing, and pharmacist register with schedule reports to optimize your medical shop or chemist store operations.',
  //       keywords: 'Pharmacy management system, Free Pharmacy software, Medical store software, Pharmacy Billing software, Medeil software',
  //       image: 'https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg'
  //     },
  //     fr: {
  //       title: 'Medeil Logiciel de gestion de pharmacie gratuit: Optimisez vos opérations',
  //       description: 'Découvrez Medeil, le logiciel complet de gestion de magasin médical conçu pour améliorer l\'efficacité des pharmacies et des pharmacies hospitalières. Découvrez des fonctionnalités telles que l\'information sur les médicaments, les détails des distributeurs, la gestion des stocks, la facturation des pharmacies et l\'enregistrement des pharmaciens avec des rapports planifiés pour optimiser vos opérations.',
  //       keywords: 'Système de gestion de pharmacie, Logiciel de pharmacie gratuit, Logiciel de magasin médical, Logiciel de facturation de pharmacie, Logiciel Medeil',
  //       image: 'https://www.medeil.com/fr/assets/medeil-pharmacy-software.jpg'
  //     },
  //     es: {
  //       title: 'Medeil Software de gestión de farmacia gratuito: Optimiza tus operaciones',
  //       description: 'Explora Medeil, el software integral para tiendas médicas diseñado para mejorar la eficiencia en farmacias y farmacias hospitalarias. Descubre funciones como información sobre medicamentos, detalles de distribuidores, gestión de inventarios, facturación de farmacias y registro de farmacéuticos con informes programados para optimizar las operaciones de tu tienda o farmacia.',
  //       keywords: 'Sistema de gestión de farmacias, Software de farmacia gratuito, Software para tienda médica, Software de facturación de farmacias, Software Medeil',
  //       image: 'https://www.medeil.com/es/assets/medeil-pharmacy-software.jpg'
  //     },
  //     pt: {
  //       title: 'Medeil Software de Gestão de Farmácia Gratuito: Otimize suas Operações',
  //       description: 'Explore Medeil, o software abrangente para lojas médicas projetado para aumentar a eficiência em farmácias e farmácias hospitalares. Descubra funcionalidades como informações sobre medicamentos, detalhes de distribuidores, gerenciamento de estoque, faturamento de farmácias e registro de farmacêuticos com relatórios agendados para otimizar as operações da sua loja ou farmácia.',
  //       keywords: 'Sistema de gestão de farmácias, Software de farmácia gratuito, Software de loja médica, Software de faturamento de farmácias, Software Medeil',
  //       image: 'https://www.medeil.com/pt/assets/medeil-pharmacy-software.jpg'
  //     }
  //   };
  
  //   if (isPlatformBrowser(this.platformId)) {
  //     const origin = window.location.origin;
  //     const path = window.location.pathname;
  //     const parts = path.split('/');
  
  //     let lang = 'en'; // Default language
  //     if (supportedLanguages.includes(parts[1])) {
  //       lang = parts[1];
  //     }
  
  //     const fullPath = path.replace(/^\/[a-z]{2}/, '');
  //     finalUrl = `${origin}/${lang}${fullPath}`;
  //     console.log(finalUrl);
      
  
  //     // Get the correct SEO data for the selected language
  //     const seoData = seoDataByLang[lang];
  
  //     // Set title and meta tags dynamically
  //     this.title.setTitle(seoData.title);
  //     const metaTags = [
  //       { name: 'description', content: seoData.description },
  //       { name: 'keywords', content: seoData.keywords },
  //       { property: 'og:title', content: seoData.title },
  //       { property: 'og:description', content: seoData.description },
  //       { property: 'og:url', content: finalUrl },
  //       { property: 'og:type', content: 'website' },
  //       { property: 'og:image', content: seoData.image }
  //     ];
  
  //     metaTags.forEach(tag => this.meta.updateTag(tag));
  //   }
  // }
  
  
  setWebsiteSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": $localize`:@@SCHEMA.WEBSITE_NAME_POS:Medeil Free Pharmacy Management Software`,
      "url": "https://www.medeil.com/en/",
      "description": $localize`:@@SCHEMA.WEBSITE_DESCRIPTION_POS:Explore Medeil, the comprehensive medical store software designed to enhance efficiency in pharmacies and hospital pharmacies. Discover features like drug information, distributor details, stock management, pharmacy billing, and pharmacist register with schedule reports to optimize your medical shop or chemist store operations.`,
      "image": "https://www.medeil.com/en/assets/img/logo/medeil_logo_1.png",
      "publisher": {
        "@type": "Organization",
        "name": "Medeil",
        "url": "https://www.medeil.com/en/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.medeil.com/en/assets/img/logo/medeil_logo_1.png"
        }
      }
    };
  
    this.jsonLdService.setData(schemaData);
  }
  
  setSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": $localize`:@@SCHEMA.SOFTWARE_NAME_POS:Medeil Free Pharmacy Management Software`,
      "url": "https://www.medeil.com/en/medeil-pharmacy-software",
      "description": $localize`:@@SCHEMA.SOFTWARE_DESCRIPTION_POS:Explore Medeil, the comprehensive medical store software designed to enhance efficiency in pharmacies and hospital pharmacies. Discover features like drug information, distributor details, stock management, pharmacy billing, and pharmacist register with schedule reports to optimize your medical shop or chemist store operations.`,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
      "image": "https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg",
      "offers": {
        "@type": "Offer",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock",
        "url": "https://www.medeil.com/en/medeil-pharmacy-software",
        "keywords": $localize`:@@SCHEMA.KEYWORDS_POS:Pharmacy management system, Free Pharmacy software, Medical store software, Pharmacy Billing software, Medeil software`
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.6",
        "ratingCount": "8864"
      }
    };
  
    this.jsonLdService.setData(schemaData);
  }
  
  setFaqSchemaData() {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": $localize`:@@FAQ.QUESTION_1_POS:Is Medeilcloud POS suitable for all types of pharmacies?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ.ANSWER_1_POS:Yes, MEDEIL is designed to cater to the needs of various types of pharmacies including retail pharmacies, hospital pharmacies and independent pharmacies.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@FAQ.QUESTION_2_POS:Is MEDEIL easy to use?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ.ANSWER_2_POS:MEDEIL is designed with user-friendly interfaces and intuitive navigation to make it easy for pharmacy staff to learn and use the software efficiently.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@FAQ.QUESTION_3_POS:Does MEDEIL offer cloud-based access?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ.ANSWER_3_POS:Yes, MEDEIL offers cloud-based access, allowing users to access the software from anywhere with an internet connection.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@FAQ.QUESTION_4_POS:What features does MEDEIL offer?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ.ANSWER_4_POS:MEDEIL offers a range of features including inventory management, prescription processing, billing and invoicing, patient records management, drug interaction checking, reporting and analytics, barcode scanning, and integration with other healthcare systems.`
          }
        }
      ]
    };
  
    this.addJsonLdToHead(faqSchema);
  }
  


  addJsonLdToHead(schema: any) {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'faq-schema';

    // Remove old schema if exists
    const oldScript = document.getElementById('faq-schema');
    if (oldScript) {
      oldScript.remove();
    }

    this.renderer.appendChild(document.head, script);
  }
ngOnInit(): void {
  if (isPlatformBrowser(this.platformId)) {
  // this.navigateToHomeWithQueryParams();
  this.mainservice.generatecaptcha();
  this.captcha = localStorage.getItem('captcha')
   // ----country list--
   this.mainservice.getCountryList().subscribe(data=>{
     console.log(data);
     this.totalcountry=data;
   })
  }
}
navigateToHomeWithQueryParams() {
  // Specify the route and query parameters
  const queryParams = { lang: sessionStorage.getItem('language'), country: sessionStorage.getItem('countryname') };

  // Navigate to the home route with the specified query parameters
  this.router.navigate(['medeilcloudpos/'], { queryParams });
}
// faq-item.model.ts
selectclass(index: number): void {
  this.selectedclass = index;
}

trialbtn(){
  window.open('https://secure.medeil.io/medeilpos/eng/23pos/#/usersignup', '_blank');


}
appstore(){
  this.ngxsmartservice.open('playstore');
}
appointment(datasource:any){
  this.enquiryForm.get('sourceRef1').setValue(datasource);
  this.ngxsmartservice.open('enquirypos');
  // this.ngxsmartservice.open('appointmentform');
}
closeModal(): void {
  this.ngxsmartservice.close('enquirypos');
  this.ngxsmartservice.close('appointmentform');
  this.enquiryForm.reset();

  this.enquiryForm.get('countryname1').setValue('0');
  this.generatecaptcha();


 this.enquiryForm.get('countryname1').setValue('0');
 this.generatecaptcha();
}
countrychange(){

  this.mainservice.getMobileCode(this.enquiryForm.get('countryname1').value).subscribe((data)=>{
    //console.log(data);
    this.dialcode=data.Dailingcode;
    console.log(this.dialcode);
   // this.registerForm.get('phonedialcode').patchValue(this.dialcode[1]);
  })
}
checkCaptcha(){

  var usercaptcha = this.enquiryForm.get('enteredcaptcha').value

  if (this.captcha == usercaptcha) {
    this.ecaptcha = false

  } else {

    this.errorcaptcha = 'Enter correct Captcha'
    this.ecaptcha = true
  }
}
generatecaptcha(){
  this.mainservice.generatecaptcha()
  this.captcha = localStorage.getItem('captcha')
}
submitenquery(){
  let valid=this.validation();
  if(valid){
    this.ngxsmartservice.close('enquirypos');
    this.ngxsmartservice.open('appointmentform');
    this.picker.open();
    this.inputField.focus();
  }

}

validation(){
  let name=this.enquiryForm.get('leadname').value
  let organizationname=this.enquiryForm.get('organizationname').value
  let primaryemail=this.enquiryForm.get('primaryemail').value
  let primaryphone=this.enquiryForm.get('primaryphone').value
  let captcha=this.enquiryForm.get('enteredcaptcha').value
  let checkbox=this.enquiryForm.get('checkbox').value

  // var usercaptcha = this.registerForm.get('enteredcaptcha').value
  if(!name){
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Please Enter Name',
      showConfirmButton: false,
      timer: 1500
    })
    return false;
  }
  else if(!organizationname){
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Please Enter Organization Name',
      showConfirmButton: false,
      timer: 1500
    })
    return false;
  }
  else if(!primaryemail){
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Please Enter Your Email',
      showConfirmButton: false,
      timer: 1500
    })
    return false;
  }
  else if(!primaryphone){
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Please Enter Your Mobile Number',
      showConfirmButton: false,
      timer: 1500
    })
    return false;
  }
  else if(!captcha){
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Please Enter Captcha',
      showConfirmButton: false,
      timer: 1500
    })
    return false;
  }
  else if(captcha != this.captcha){
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Please Enter Correct Captcha',
      showConfirmButton: false,
      timer: 1500
    })
    return false;
  }
  else if(checkbox==false){
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Please Select Accept & Terms condition',
      showConfirmButton: false,
      timer: 1500
    })
    return false;
  }


  return true
}
slectdate(event: any){
  this.showElement=true;
  const selectedDate = event.value;
  const finalDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
  this.enquiryForm.get('appointmentdate').setValue(finalDate);
 this.currentTime = new Date();

 let map={
  "timezone":this.timezone,
  "orginaltimezone":this.currentTime
}
this.mainservice.gettimeSlots(map).subscribe(data=>{
  this.timeSlots = data[0].map((time:any)=> {
    const [hours, minutes] = time.split(':');
    const hours12 = ((parseInt(hours) + 11) % 12) + 1;
    const ampm = parseInt(hours) < 12 ? 'AM' : 'PM';
    return `${hours12}:${minutes} ${ampm}`;
  });
  this.showElement=false;
  console.log(this.timeSlots);
})

  this.appointment_time=true;
}
selectTime(time: string): void {
  const currentTime = new Date();
  const formattedTime = this.datePipe.transform(currentTime, 'hh:mm:ss a');
  console.log(formattedTime);
  this.selectedTime = time;
  // this.enquiryForm.get('apptotime').setValue(time);
  this.enquiryForm.get('appfrmtime').setValue(time);

}
savelead(){
  this.showElementsave=true;



  // if (valid) {

    let phone = this.enquiryForm.get('primaryphone').value

    let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
    this.enquiryForm.get('primaryphone').setValue(mobileno)

     console.log('form',this.enquiryForm.value);

this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
  this.leads = data
  // console.log("this.leads",this.leads)
  if (data) {
    this.showElementsave=false;
    // this.enquiryForm.reset()
    // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
    this.enquiryForm.reset();
    this.showElement=false;
    // this.submitenquery();
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Data saved successfully',
      text: 'We will contact you shortly.',
      showConfirmButton: false,
      timer: 4000
    });
    this.ngxsmartservice.close('enquirypos');
    this.ngxsmartservice.close('appointmentform');
    this.enquiryForm.reset();
  }
   else{
    this.enquiryForm.get('primaryphone').setValue(phone);
    // this.showElement=false;
  }
  this.enquiryForm.get('countryname1').setValue('0');
  this.generatecaptcha();
})

}
closepopup(){
  this.ngxsmartservice.close('myModal');
  this.enquiryForm.reset();

  this.enquiryForm.get('countryname1').setValue('0');
  this.generatecaptcha();
}
closepopup1(){
  this.ngxsmartservice.close('myModal1');
  this.enquiryForm.reset();

  this.enquiryForm.get('countryname1').setValue('0');
  this.generatecaptcha();
}
trynowbtn(data:any){
  // this.enquiryForm.reset();
  this.enquiryForm.get('sourceRef1').setValue(data);
  this.ngxsmartservice.open('myModal');

}
broucher(data:any){
  this.enquiryForm.get('sourceRef1').setValue(data);
  this.ngxsmartservice.open('myModal1');
}
savebroucher() {
  let valid = this.validation();


  if (valid) {
    this.showElementsave = true;
    let phone = this.enquiryForm.get('primaryphone').value;
    let mobileno = this.enquiryForm.get('phonedialcode').value + this.enquiryForm.get('primaryphone').value;
    this.enquiryForm.get('primaryphone').setValue(mobileno);

    console.log('form', this.enquiryForm.value);

    this.mainservice.savelead(this.enquiryForm.value).subscribe(
      (data: any) => {

        this.leads = data;

        if (data) {
          this.enquiryForm.reset();
          this.showElementsave = false;
          Swal.fire({
            title: "Do you want to view the Brochure?",
            // showDenyButton: true,
            // showCancelButton: true,
            confirmButtonText: "yes",

          }).then((result) => {

            if (result.isConfirmed) {

          const url = 'https://medeilpos.blob.core.windows.net/websitedocuments/medeilcloudposbrochure.pdf';
          window.open(url, '_blank');
            }
          });
          this.ngxsmartservice.close('myModal1');


        } else {
          this.enquiryForm.get('primaryphone').setValue(phone);
          this.showElement = false;
        }

        this.enquiryForm.get('countryname1').setValue('0');
        this.generatecaptcha();
      },
      (error: any) => {
        console.error('Error saving form', error);
        this.enquiryForm.get('primaryphone').setValue(phone);
        this.showElement = false;
      }
    );
  } else {
    this.showElement = false;
  }
}
viewbroshure(){

  const url = 'https://medeilpos.blob.core.windows.net/websitedocuments/medeilcloudposbrochure.pdf';
   window.open(url, '_blank');
}
savesignup(){


  let valid=this.validation();

  if (valid) {
    this.showElementsave=true;
    let phone = this.enquiryForm.get('primaryphone').value

    let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
    this.enquiryForm.get('primaryphone').setValue(mobileno)

     console.log('form',this.enquiryForm.value);

this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
  this.leads = data
  // console.log("this.leads",this.leads)
  if (data) {
    // this.enquiryForm.reset()
    // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
    this.enquiryForm.reset();
    this.showElementsave=false;
    // this.submitenquery();
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Data saved successfully',
      text: 'We will contact you shortly.',
      showConfirmButton: false,
      timer: 4000
    });
    this.ngxsmartservice.close('myModal');
  }
   else{
    this.enquiryForm.get('primaryphone').setValue(phone);
    this.showElement=false;
  }

 this.enquiryForm.get('countryname1').setValue('0');
 this.generatecaptcha();
})

  }
  else{
    this.showElement=false;
  }


}
}
